import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Tentar recuperar do localStorage, padrão é inglês (US)
    const savedLanguage = localStorage.getItem('language');
    // Validar se o idioma salvo é válido (en, pt, es), caso contrário usar 'en' como padrão
    const validLanguages = ['en', 'pt', 'es'];
    if (savedLanguage && validLanguages.includes(savedLanguage)) {
      return savedLanguage;
    }
    // Padrão sempre é inglês (US)
    return 'en';
  });

  useEffect(() => {
    // Salvar no localStorage quando mudar
    localStorage.setItem('language', language);
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

